import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { GTMService } from '../../../shared/gtm.service';
import { isIFrameSameOrigin } from '../../../shared/helpers/is-same-origin';
import { OeAppPersonService } from '../../../shared/oe-app-person.service';
import { OeAppService } from '../../../shared/oe-app.service';

export const enum PcReservationEventType {
  CLOSE = 'private_class_reservation_close_event',
  COMPLETE = 'private_class_reservation_complete_event',
  TRACKING = 'private_class_reservation_tracking_event',
}

@Component({
  selector: 'lp2-pc-reservation-iframe',
  encapsulation: ViewEncapsulation.None,
  template: `
    <lp2-close-button class="pc-reservation-close" (click)="onCloseClick()"></lp2-close-button>
    <iframe lp2UserwaySync class="pc-reservation-frame border-0 w-100" [src]="url | safeUrl"></iframe>
  `,
  styleUrls: ['./pc-reservation-iframe.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PcReservationIframeComponent implements OnInit, OnDestroy {
  @Output() completed = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  public url: string;
  private boundHandler: (event: MessageEvent) => void;

  constructor(
    private oeApp: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    private gtmService: GTMService
  ) {}

  ngOnInit() {
    this.url =
      `${this.oeApp.webPrivateClassesReservationHost}` +
      `?env=${this.oeApp.environment}` +
      `&lang=${this.oeAppPersonService.preferredLang}`;

    this.boundHandler = this.handleEvents.bind(this);
    window.addEventListener('message', this.boundHandler, false);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.boundHandler);
  }

  public onCloseClick() {
    this.closed.emit();
  }

  public handleEvents(event: MessageEvent) {
    const { data: message, origin } = event;

    if (!isIFrameSameOrigin(this.oeApp.webPrivateClassesReservationHost, origin)) {
      return;
    }

    switch (message.type) {
      case PcReservationEventType.COMPLETE:
        this.completed.emit();
        break;
      case PcReservationEventType.CLOSE:
        this.closed.emit();
        break;
      case PcReservationEventType.TRACKING:
        this.gtmService.sendGA4Event(message.data);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/pc-reservation-iframe/pc-reservation-iframe.component.ts